import { observer } from "mobx-react"
import { Flex, Typography } from "antd"

import css from "../index.module.css"

export const RightSideTransferIo = observer(() => {
  return (
    <Flex
      align="center"
      className={css.kybWrapper}
      gap={16}
      justify="center"
      vertical
    >
      <Flex gap={16} style={{ marginTop: "auto" }} vertical>
        <Flex
          align="center"
          style={{ padding: 32, textAlign: "center" }}
          vertical
        >
          <Typography.Title className={css.kybSubtitle}>
            Thank you for registering!
          </Typography.Title>
          <Typography.Text>
            Your dedicated account manager will contact you shortly to activate
            your account
          </Typography.Text>
        </Flex>
      </Flex>

      <Flex
        align="center"
        gap={4}
        style={{
          fontSize: 12,
          marginTop: "auto",
          textAlign: "center",
        }}
        vertical
      >
        <Typography.Text style={{ color: "#7E7E7E" }}>
          Learn more about our API{" "}
          <Typography.Link
            href="https://developers.transferio.io"
            rel="noopener noreferrer"
            target="_blank"
            underline
          >
            documentation
          </Typography.Link>
        </Typography.Text>
      </Flex>
    </Flex>
  )
})
